import React, { useState } from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import ModalVideo from 'react-modal-video';

const HeroTwo = () => {
  const [isOpen, setOpen] = useState(false);
  
  return (
    <>
      <div
        className="hero-wrapper hero-2"
        id="hero"
        style={{ backgroundImage: "url(assets/img/home/1.png)" }}
      >
        <div
          className="hero-overlay"
          style={{ backgroundImage: "url(assets/img/hero/hero_overlay_1.png)" }}
        >
          {" "}
        </div>

        <div className="container">
    <div className="hero-style2">
        <h1 className="hero-title text-white">
            Especialistas em mão de obra para o segmento alimentício
        </h1>
        <p className="hero-text text-white">
            Desde 2023, o Grupo Rocvel aplica uma metodologia própria e sólida para o setor de alimentos. Fornecemos mão de obra especializada e rápida para indústrias, redes de distribuição e varejo alimentar, garantindo conformidade operacional, agilidade e máxima assertividade nas contratações.
        </p>
        <div className="btn-group">
            <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações." className="global-btn">
                Falar com um especialista
                <img src="assets/img/icon/right-icon.svg" alt="Seta Direita Rocvel" />
            </Link>
            <div className="media-wrap">
                <div className="icon">
                    <span
                        className="play-btn popup-video"
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpen(true)}
                    >
                        <i className="fas fa-solid fa-play" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

      </div>
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="8dTfgnkmJGs"
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default HeroTwo;